/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="reports.module.ts" />
/// <reference path="reports.context.ts" />
///<reference path="../../components/models/meevo.model.custom.ts"/>
///<reference path="../../components/tracking/trackingItem.ts"/>
///<reference path="../../components/common/security.keys.ts"/>
///<reference path="../../components/common/security.parts.ts"/>


module Meevo.Plugins.Reports {

    import PageStateEnum = Meevo.Model.PageStateEnum;
    import Timer = NodeJS.Timer;

    class ReportsController {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            '$sce',
            '$q',
            'meevo.plugins.reports.ReportsHelper',
            '$translate',
        ];

        reportParameterForm: angular.IFormController;
        reportUrl: string;
        context: IReportsContext;
        reportLoadTimeout: Timer;
        params: string;
        bearerToken: string;

        protected addSecurityKey: string;
        protected editSecurityKey: string;
        protected deleteSecurityKey: string;
        protected securityKeys = Meevo.Components.Common.SecurityKeys;
        protected securityParts = Meevo.Components.Common.SecurityParts;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $sce: angular.ISCEService,
            protected $q: angular.IQService,
            protected reportsHelper: IReportsHelper,
            protected $translate: angular.translate.ITranslateService) {
            this.context = new ReportsContext(
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                busyService,
                securityService,
                $scope,
                $sce,
                $q,
                reportsHelper,
                $translate
            );

            this.buildCrudSecurityKeys();

            this.securityService
                .checkSection(this.securityKeys.REPORTS)
                .finally(() => {
                    if (!contextParams.params) {
                        this.context.activate();
                    }
                });

            this.setConvoReportContext(contextParams.params);
            this.loadContextData(contextParams.params);

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (evt, state, params: { convoInput: string; report?: string; }) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.reports) {
                    return;
                }

                if (this.context) {
                    this.context.searchFilter = '';
                }

                this.setConvoReportContext(params);
                this.loadContextData(params);
            });

            this.$scope.$watch(() => this.identityService.current().sessionId, (newValue: string, oldValue: string) => {
                if (newValue === oldValue || this.context.showMenuType !== PageStateEnum.Report) {
                    return;
                }

                this.context.goBack();
            });
        }

        getBrowserName(): string {
            var browserNames = ['Firefox', 'SamsungBrowser', 'Opera', 'OPR', 'Trident', 'Edge', 'Chrome', 'Safari'];
            var sBrowser, sUsrAg = navigator.userAgent;
            // The order matters here, and this may report false positives for unlisted browsers.
            for (var i = 0; i < browserNames.length; i++) {
                var index = sUsrAg.indexOf(browserNames[i]);
                if (index > -1) {
                    sBrowser = browserNames[i];
                    break;
                }
                else
                    sBrowser = "unknown";
            }
            return sBrowser;
        }


        isIFrameSupportBrowser(): boolean {
            var newTabBrowsers = 'Safari';
            var results = ((angular.equals(this.getBrowserName(), newTabBrowsers) == true) ? false : true);
            //console.log("isIFrameSupportBrowser: " + results);
            return results;
        };

        isIFrameSupportAndHtml(): boolean {
            return this.isIFrameSupportBrowser() && this.context.reportDeliveryFileFormatEnum == "HTML" 
        };

        protected setConvoReportContext(params): any {
            if (!params) {
                return;
            }
            if (params.report) {
                // Need to create a reportContext when params are from a convo
                params.reportContext = {
                    id: params.reportId,
                    reportCatId: params.reportCatId
                };
                params.action = 'GOTO_REPORT';

                return;
            }
            if (params.categoryId) {
                params.reportContext = {
                    reportCatId: params.categoryId
                };
                params.action = 'GOTO_REPORT_CATEGORY';

                return;
            }
        }

        protected loadContextData(params) {
            if (!params || !params.action) {
                this.context.activate();

                return;
            }

            if (params.action === 'GOTO_REPORT') {
                this.context.loadReportFromParams(params);
            }
            if (params.action === 'GOTO_REPORT_CATEGORY') {
                this.context.loadReportCategoryFromParams(params);
            }
        }

        /**
         * Builds a security key for the CRUD commands based on the base key
         * */
        protected buildCrudSecurityKeys() {
            let baseKey = this.securityKeys.REPORTS;

            this.addSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
        }

        submitForm = ($event): void => {
            if (this.context.hierarchyForm) {
                if (this.context.hierarchyForm.$invalid) {
                    $event.preventDefault();
                    if (this.context.hierarchyForm.$error.noBusinessTypesAssociated) {
                        this.modalService.alert('LABEL_THIS_REPORT_CANNOT_BE_RUN', Meevo.Components.Modal.ModalTranslationModes.Translate);
                    }

                    if (this.context.hierarchyForm.$error.locationsSelected) {
                        this.modalService.warning('LABEL_NO_LOCATIONS_ARE_ASSOCIATED_REPORT_CANNOT_BE_RUN', Meevo.Components.Modal.ModalTranslationModes.Translate);
                    }

                    return;
                } 
            }

             if (this.context.selectedReport.id === 221) {
                // limit the number of locations for COMES10
                let locations = this.context.reportModel['locationForHierarchy']
                if (locations && locations.length > 30) {
                    $event.preventDefault();
                    this.modalService.alert('LABEL_LOCATIONS_LIMIT_COMES10', Meevo.Components.Modal.ModalTranslationModes.Translate)
                    return;
                }
            }
             if (this.context.selectedReport.id === 244) {
                // limit the number of locations for CODE040
                let locations = this.context.reportModel['locationForHierarchy']
                if (locations && locations.length > 10) {
                    $event.preventDefault();
                    this.modalService.alert('LABEL_LOCATIONS_LIMIT_CODE040', Meevo.Components.Modal.ModalTranslationModes.Translate)
                    return;
                }
            }

            if (!this.canRunInSandbox()) {
                $event.preventDefault();
                this.modalService.error('LABEL_REPORT_CANNOT_BE_RUN_IN_SANDBOX', Meevo.Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            if (this.isIFrameSupportAndHtml())
                this.context.showMenuType = PageStateEnum.Report
            else
                this.context.showMenuType = PageStateEnum.Controls; //if we want to load report in new tab and show controls screen only


            let formCtrl = this.reportParameterForm,
                json = {
                    reportParams: {}
                };
            this.reportUrl = this.$sce.trustAsResourceUrl(`${this.identityService.current().systemSettings.reportsUrl}Report/LoadReport/${this.context.selectedReport.shortCut}`);

            if (formCtrl.$valid) {
                // When a report is loading, we should see a message that says Report Loading Please Wait.
                if (this.isIFrameSupportAndHtml())
                    this.busyService.start('MESSAGE_REPORT_LOADING');


                // If there is an extended loading time > 15 seconds, the message should be updated
                if (this.isIFrameSupportAndHtml())
                    this.reportLoadTimeout = setTimeout(() => this.busyService.start('MESSAGE_REPORT_STILL_LOADING', null, true), 15000);

                // Create a copy of the model in order to manipulate data(in 'preSubmit()') and not affect the view
                this.context.reportModelForSubmit = angular.copy(this.context.reportModel);

                // clientInformation is not used for any reports so remove it
                delete this.context.reportModelForSubmit['clientInformation'];

                this.preSubmit();

                for (let key in this.context.reportModelForSubmit) {
                    if (this.context.reportModelForSubmit.hasOwnProperty(key)) {
                        if (angular.isDate(this.context.reportModelForSubmit[key])) {
                            let timeZoneOffset = this.context.reportModelForSubmit[key].getTimezoneOffset() * 60000;

                            json.reportParams[key] = moment(+this.context.reportModelForSubmit[key] - timeZoneOffset).toISOString();
                        } else {
                            json.reportParams[key] = this.context.reportModelForSubmit[key];
                        }
                    }
                }
                this.params = JSON.stringify(json.reportParams);
                this.bearerToken = window['bearerToken'];

                this.dataService.add('Alert/Trigger/ReportIsRun', {
                    reportId: this.context.selectedReport.id,
                    shortcut: this.context.selectedReport.shortCut,
                    displayName: this.context.selectedReport.displayName
                })
            }
        };

        /**
         * Close plugin
         * */
        closeContext = (): void => {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }

        /**
         * Do manipulations with a model before submitting the form.
         * Important note: Use this.context.reportModelForSubmit.
         */
        preSubmit(): void {
            // Check for name translation and add to report parameters if applicable
            var translatedDisplayName = this.$translate.instant(`LABEL_${this.context.selectedReport.shortCut.toUpperCase()}_DISPLAY_NAME`);
            if (translatedDisplayName && translatedDisplayName.indexOf('LABEL_') === -1) {
                this.context.reportModelForSubmit['displayName'] = translatedDisplayName;
            }
        
            // User Story 39526: Report Controls for AQ030 (Booking Traffic)
            // BookingTrafficType: DayofWeek, EmployeeSummary, TimeofDay
            if (this.context.reportControls.filter(control => control.id === 28).length === 1) {
                let parameterNames = this.context.reportControls[0].parameters.map((p) => p.name);

                if (this.context.reportModelForSubmit[parameterNames[0]] === 'DayofWeek' || this.context.reportModelForSubmit[parameterNames[0]] === 'TimeofDay') {
                    this.context.reportModelForSubmit[parameterNames[5]] = []; // BookingTrafficEmployeeCategoryList_TBL
                    this.context.reportModelForSubmit[parameterNames[6]] = []; // BookingTrafficEmployeeList_TBL
                }

                if (this.context.reportModelForSubmit[parameterNames[0]] === 'DayofWeek') {
                    // BookingTrafficStartTime = BookingTrafficStartDate
                    this.context.reportModelForSubmit[parameterNames[3]] = this.context.reportModel[parameterNames[1]];

                    // BookingTrafficEndTime = BookingTrafficEndDate
                    this.context.reportModelForSubmit[parameterNames[4]] = this.context.reportModel[parameterNames[2]];
                }

                this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModel[parameterNames[1]];
                this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModel[parameterNames[2]];

                if (this.context.reportModelForSubmit[parameterNames[0]] !== 'DayofWeek') {
                    this.context.reportModelForSubmit['SharedReportHeaderStartTime'] = this.context.reportModel[parameterNames[3]];
                    this.context.reportModelForSubmit['SharedReportHeaderEndTime'] = this.context.reportModel[parameterNames[4]];
                }
            }

            if (this.context.reportModel.hasOwnProperty('selectedYear') && this.context.reportModel['selectedPreset']['status'] === 27) {
                // date range preset is 'specific year' so assign dates from the year selected
                this.context.reportModelForSubmit['StartDateYear'] = moment([this.context.reportModel['selectedYear']]).toDate();
                this.context.reportModelForSubmit['EndDateYear'] = moment([this.context.reportModel['selectedYear']]).endOf('year').toDate();
            }

            if (this.context.selectedReport.shortCut === 'MR110' && this.context.reportModel['isPaymentTypesAllSelected']) {
                this.context.reportModelForSubmit['PaymentMover_TBL'] = [];
            }

            if (
                this.context.selectedReport.shortCut === 'MR260' &&
                this.context.reportModel['DisplaySalesByMR260'] === 'Week' &&
                this.context.reportModel['selectedPreset']['status'] === 19
            ) {
                this.context.reportModelForSubmit['StartDateYear'] = moment().subtract(55, 'weeks').toDate();
                this.context.reportModelForSubmit['EndDateYear'] = moment().toDate();
            }

            // User Story 41834:Report Control behavior for DR020 (local)
            if (this.context.selectedReport.shortCut === 'DR020' && this.context.reportModelForSubmit['viewReportBy'] === 'SummaryView') {
                // set default values to fields which are hidden
                this.context.reportModelForSubmit['displayPhoneNumber'] = false;
                this.context.reportModelForSubmit['FieldOrderBy'] = 'ReferralType';
            }

            if (this.context.selectedReport.shortCut === 'MR035' && this.context.reportModelForSubmit['viewReportBy'] === 'DetailView') {
                this.context.reportModelForSubmit['footerString'] = this.$translate.instant('LABEL_MR035_FOOTER_NOTE');
            }

            // Report Controls for MI105 (local)
            if (this.context.selectedReport.shortCut === 'MI105' && this.context.reportModelForSubmit['viewInventoryReportBy'] === 'Main') {
                this.context.reportModelForSubmit['ReturnHeaderIdList_TBL'] = [];
            }

            // Report Controls for MI025 (local)
            if (this.context.selectedReport.shortCut === 'MI025' && this.context.reportModelForSubmit['SortReportBy'] !== 'FloorLocation') {
                this.context.reportModelForSubmit['FloorLocations_TBL'] = [];
            }

            if (this.context.selectedReport.shortCut === 'CODE040') {
                this.context.reportModelForSubmit['runForItems'] = 'MultiplePayrollPeriods';
            }

            // Report Controls for MI105 (local)
            if (this.context.selectedReport.shortCut === 'DP005') {
                if (!this.context.reportModelForSubmit['SpecificNumber']) {
                    delete this.context.reportModelForSubmit['NumberOfLabels'];
                }
                if (this.context.reportModelForSubmit['ProductListWithLabelCounts_TBL'].length) {
                    this.context.reportModelForSubmit['ProductListWithLabelCounts_TBL'].forEach((item) => {
                        item['labelCount'] = item.numberOfLabels;
                        delete item.barCode;
                        delete item.generalDisplayName;
                        delete item.numberOfLabels;
                        delete item.selected;
                    });
                }
            }

            if (['DE040', 'DE044'].indexOf(this.context.selectedReport.shortCut) !== -1) {
                this.context.reportModelForSubmit['PayPeriodEmployeeCategories_TBL'] = [];
            }

            if (this.context.selectedReport.shortCut === 'DE040' && !this.context.reportModelForSubmit.hasOwnProperty('MultiStartDate')) {
                this.context.reportModelForSubmit['MultiStartDate'] = this.context.reportModelForSubmit['SharedReportHeaderStartDate'];
                this.context.reportModelForSubmit['MultiEndDate'] = this.context.reportModelForSubmit['SharedReportHeaderEndDate'];
            }

            if (this.context.selectedReport.shortCut === 'DE040' && this.context.reportModelForSubmit['runForPeriods'] === 'MultiplePayrollPeriods') {
                this.context.reportModelForSubmit['DisplayBreakdownsDE040'] = false;
            }

            if (['AQ020', 'AQ022'].indexOf(this.context.selectedReport.shortCut) > -1) {
                if (this.context.reportModelForSubmit['isServicesAllSelected']) {
                    this.context.reportModelForSubmit['ServiceCategoryList_TBL'] = null;
                    this.context.reportModelForSubmit['ServiceList_TBL'] = null;
                }

                if (this.context.selectedReport.shortCut === 'AQ020') {
                    this.context.reportModelForSubmit['NoOfClientVisitNotes'] = 8;
                    this.context.reportModelForSubmit['NoOfServiceHistory'] = 21;
                    this.context.reportModelForSubmit['NoOfRetailHistory'] = 21;
                    this.context.reportModelForSubmit['NoOfTodaysAppointments'] = 15;
                    this.context.reportModelForSubmit['NoOfFutureAppointments'] = 5;
                } else {
                    this.context.reportModelForSubmit['NoOfClientVisitNotes'] = 3;
                    this.context.reportModelForSubmit['NoOfServiceHistory'] = 5;
                    this.context.reportModelForSubmit['NoOfRetailHistory'] = 5;
                    this.context.reportModelForSubmit['NoOfTodaysAppointments'] = 10;
                    this.context.reportModelForSubmit['NoOfFutureAppointments'] = 3;
                }
            }

            if (this.context.selectedReport.shortCut === 'MR130') {
                if (typeof this.context.reportModelForSubmit['SaleDate'] === 'number') {
                    this.context.reportModelForSubmit['SaleDate'] = new Date(this.context.reportModelForSubmit['SaleDate'], 0);
                }
            }

            if (this.context.selectedReport.shortCut === 'DC090' && this.context.reportModelForSubmit['OnlyDisplayCardsToBeExp'] === false || this.context.reportModelForSubmit['CardExpStatus'] === 'Expired') {
                this.context.reportModelForSubmit['OnlyDisplayCardsToBeExpFromDate'] = null;
                this.context.reportModelForSubmit['OnlyDisplayCardsToBeExpToDate'] = null;
            }

            if (this.context.selectedReport.shortCut === 'DC090' && this.context.reportModelForSubmit['CardsUnusedSince'] === false || this.context.reportModelForSubmit['CardExpStatus'] === 'Expired') {
                this.context.reportModelForSubmit['CardsUnusedSinceDate'] = null;
            }

            //MI100 30122
            if (this.context.selectedReport.shortCut === 'MI100' && this.context.reportModelForSubmit['ViewPurchaseOrdersReportBy'] === 'OrderSummary') {
                this.context.reportModelForSubmit['DistributorPOMoverList_TBL'] = [];
                this.context.reportModelForSubmit['PurchaseOrdersMoverList_TBL'] = [];
            }
            //DC065 ClientSearchClientSelectorTBL
            if (this.context.selectedReport.shortCut === 'DC065' && this.context.reportModelForSubmit['isAllClientChecked'] === true) {
                this.context.reportModelForSubmit['ClientSearchClientSelectorTBL'] = [];
            }
            //DC065 Visit Note Type
            if (this.context.selectedReport.shortCut === 'DC065' && this.context.reportModelForSubmit['VisitNoteType_TBL'] === '') {
                this.context.reportModelForSubmit['VisitNoteType_TBL'] = [];
            }

            if (this.context.selectedReport.shortCut === 'DR030' && !!this.context.reportModelForSubmit['isAllEmployeesSelected']) {
                this.context.reportModelForSubmit['EmployeeOnlyMover_TBL' ] = [];
            }

            if (this.context.reportModelForSubmit['categories']) {
                delete this.context.reportModelForSubmit['categories'];
            }

            if (!this.context.reportModelForSubmit.hasOwnProperty('SharedReportHeaderStartDate')) {
                if (this.context.reportModelForSubmit.hasOwnProperty('StartDate')) {
                    this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['StartDate'];
                }
                else {
                    //
                    switch (this.context.selectedReport.shortCut) {
                        case 'DE045':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['HireTerminatedStartDate'];
                            break;
                        case 'MR245':
                        case 'MR100':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['OpenCloseHistoryStartDate'];
                            break;
                        case 'DB050':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = moment(this.context.reportModelForSubmit['MonthPickerStartDate']).set('date', 1).toDate();
                            break;
                        case 'DB015':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['MembershipStatusStartDate'];
                            break;
                        case 'MI105':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['InventoryReturnsStartDate'];
                            break;
                        case 'MR260':
                            this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = this.context.reportModelForSubmit['StartDateYear'];
                            break;

                    }
                }
            }

            if (!this.context.reportModelForSubmit.hasOwnProperty('SharedReportHeaderStartTime')) {
                if (this.context.reportModelForSubmit.hasOwnProperty('StartTime')) {
                    this.context.reportModelForSubmit['SharedReportHeaderStartTime'] = this.context.reportModelForSubmit['StartTime'];
                } else if (this.context.reportModelForSubmit.hasOwnProperty('startTime')) {
                    this.context.reportModelForSubmit['SharedReportHeaderStartTime'] = this.context.reportModelForSubmit['startTime'];
                } else {
                    //
                    switch (this.context.selectedReport.shortCut) {
                        case 'MR245':
                        case 'MR100':
                            this.context.reportModelForSubmit['SharedReportHeaderStartTime'] = this.context.reportModelForSubmit['OpenCloseHistoryStartTime'];
                            break;
                    }
                }
            }

            if (!this.context.reportModelForSubmit.hasOwnProperty('SharedReportHeaderEndDate')) {
                if (this.context.reportModelForSubmit.hasOwnProperty('EndDate')) {
                    this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['EndDate'];
                }
                else {
                    switch (this.context.selectedReport.shortCut) {
                        case 'DE045':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['HireTerminatedEndDate'];
                            break;
                        case 'MR245':
                        case 'MR100':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['OpenCloseHistoryEndDate'];
                            break;
                        case 'DB050':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['MonthPickerEndDate'];
                            break;
                        case 'DB015':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['MembershipStatusEndDate'];
                            break;
                        case 'MI105':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['InventoryReturnsEndDate'];
                            break;
                        case 'MR260':
                            this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = this.context.reportModelForSubmit['EndDateYear'];
                            break;
                    }
                }
            }

            if (!this.context.reportModelForSubmit.hasOwnProperty('SharedReportHeaderEndTime')) {
                if (this.context.reportModelForSubmit.hasOwnProperty('EndTime')) {
                    this.context.reportModelForSubmit['SharedReportHeaderEndTime'] = this.context.reportModelForSubmit['EndTime'];
                } else if (this.context.reportModelForSubmit.hasOwnProperty('endTime')) {
                    this.context.reportModelForSubmit['SharedReportHeaderEndTime'] = this.context.reportModelForSubmit['endTime'];
                } else {
                    //
                    switch (this.context.selectedReport.shortCut) {
                        case 'MR245':
                        case 'MR100':
                            this.context.reportModelForSubmit['SharedReportHeaderEndTime'] = this.context.reportModelForSubmit['OpenCloseHistoryEndTime'];
                            break;
                    }
                }
            }

            if (this.context.selectedReport.shortCut === 'AQ225') {
                if (this.context.reportModelForSubmit['AppointmentCategory']) {
                    this.context.reportModelForSubmit['AppointmentCategoryDisplayName'] = this.context.reportModelForSubmit['AppointmentCategory'].displayName;
                    this.context.reportModelForSubmit['AppointmentCategory'] = this.context.reportModelForSubmit['AppointmentCategory'].id;

                }
                else {
                    this.context.reportModelForSubmit['AppointmentCategory'] = null
                }

                if (this.context.reportModelForSubmit['isAllSelected']) {
                    this.context.reportModelForSubmit['EmployeeCategoryList_TBL'] = null;
                }
            }

            if (this.context.selectedReport.shortCut === 'MA240') {
                // convert numeric strings to numbers, excluding client membership filter
                Object.keys(this.context.reportModelForSubmit).forEach(key => {
                    if (key !== this.context.reportControls[0].parameters[1].name) {
                        this.context.reportModelForSubmit[key] = +this.context.reportModelForSubmit[key].replace(/%/g, '');
                    }
                });

                // add start date and end date for usage in the header trdx
                this.context.reportModelForSubmit['SharedReportHeaderStartDate'] = moment().subtract(12, 'months').date(1);
                this.context.reportModelForSubmit['SharedReportHeaderEndDate'] = moment().date(0);

                // format string for header start/end dates
                this.context.reportModelForSubmit['reportFromToFormat'] = 'For: {0} - {1}';
            }

            if (this.context.selectedReport.shortCut === 'MR260') {
                let forLineString: string;
                if (this.context.reportModel['selectedPreset']['status'] === 19) {
                    forLineString = this.$translate.instant('LABEL_LAST_THIRTEEN_MONTHS')
                } else {
                    forLineString = moment(this.context.reportModelForSubmit['StartDateYear']).year().toString();
                }
                this.context.reportModelForSubmit['reportFromToFormat'] = 'For: ' + forLineString;
            }

            if (!this.context.reportModelForSubmit.hasOwnProperty('clientSortOrderEnum')) {
                // return sort order for use in the trdx
                this.context.reportModelForSubmit['clientSortOrderEnum'] = this.appSettings.APP_BUSINFOSETTINGS.clientsSettings.defaultClientSortOrder;
            }

            if (['COMES10'].indexOf(this.context.selectedReport.shortCut) !== -1) {
                this.context.reportModelForSubmit['footerHeight'] = '0.4in';
            }


            if (['MR035'].indexOf(this.context.selectedReport.shortCut) !== -1) {
                this.context.reportModelForSubmit['footerHeight'] = '0.3in';
            }

            if (this.context.selectedReport.shortCut === 'MR061') {
                this.context.reportModelForSubmit['StartYearDate'] = moment(`${this.context.reportModelForSubmit['StartYearDate']}`).utc().startOf('year').toISOString();
                this.context.reportModelForSubmit['EndYearDate'] = (<any>moment()).endOf('year').utc(true).toISOString();

            }

            if ((this.context.selectedReport.shortCut === 'MR055' || this.context.selectedReport.shortCut === 'MR126') 
                    && this.context.reportModelForSubmit['DisplayFullGiftCardNumbers']) {
                const trackingItem = new Model.TrackingItem(Model.NounEnum.Report, Model.VerbEnum.ReportRun, null, null, `${this.context.selectedReport.shortCut} ${this.$translate.instant('TEXT_DISPLAY_FULL_GIFT_CARD_NUMBER')}`);
                this.trackingService.saveTrackingInfo(trackingItem);
            }

            if (this.context.selectedReport.shortCut === 'AQ000') {
                this.context.reportModelForSubmit['EmployeesAndUsersIsAllEmployeesSelected'] = this.context.reportModelForSubmit['isAllEmployeesSelected'];
                this.context.reportModelForSubmit['EmployeesAndUsersIsAllUsersSelected'] = this.context.reportModelForSubmit['isAllUsersSelected'];
            }

            if (device.os === 'android') {
                this.context.reportModelForSubmit['isAndroidDevice'] = true;
            }
        }

        onReportLoad() {
            clearTimeout(this.reportLoadTimeout);
            $(window).off('message');
            $(window).on('message', (e) => {
                console.debug('iframe mouse events', e);
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.REFRESH_LOCKOUT_LAST_EVENT_TIME);
            });

            this.busyService.stop(true);
        }

        canRunInSandbox(): boolean {
            try {
                var settings = this.identityService.current().systemSettings;
                if (settings.isSandboxEnvironment) {
                    return this.identityService["identity"].isSingleLocation
                        ? settings.canRunReportsInSandboxSingleLocation
                        : settings.canRunReportsInSandboxMultiLocation;
                } else {
                    return true;
                }
            } catch (e) {
                return true;
            }
        }


        openClientSelection(): any {
            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.basicEmailMarketing,
                stateParams: null
            });
            return true;;
        }
    }

    angular.module('meevo.plugins.reports')
        .controller('meevo.plugins.reports.ReportsController', ReportsController);
}
